const transformDataToDays = (data, intervalHours, map = point => point) => {
  const dataPointsPerDay = 24 / intervalHours;
  const numberOfDays = data.length / dataPointsPerDay;
  return [...Array(numberOfDays)].map((_, index) => {
    const start = dataPointsPerDay * index;
    const end = start + dataPointsPerDay;
    return data.slice(start, end).map(map);
  });
};

export default transformDataToDays;



// WEBPACK FOOTER //
// ./src/reducers/components/graphs/helpers/transformDataToDays.js